export const NAMESPACE = 'newsletter';
export const NEWLY_SUBSCRIBED_PARAM = 'nwl-subscribed';
